import { z } from "zod";

export const CloudinaryUploadResponseSchema = z.object({
  config: z.any(),
  data: z.object({
    access_mode: z.string().optional(),
    api_key: z.string().optional(),
    asset_id: z.string().optional(),
    bytes: z.number().optional(),
    created_at: z.string().optional(),
    duration: z.number().optional(),
    etag: z.string().optional(),
    folder: z.string().optional(),
    format: z.string().optional(),
    height: z.number().optional(),
    pages: z.number().optional(),
    placeholder: z.boolean().optional(),
    public_id: z.string().optional(),
    resource_type: z.string().optional(),
    secure_url: z.string(),
    signature: z.string(),
    tags: z.array(z.string()).optional(),
    type: z.string().optional(),
    url: z.string(),
    version: z.number().optional(),
    version_id: z.string().optional(),
    width: z.number().optional(),
  }),
  headers: z.any(),
  request: z.any(),
  status: z.number(),
  statusText: z.string(),
});

export type CloudinaryUploadResponse = z.infer<typeof CloudinaryUploadResponseSchema>;
